import React, { Component } from "react";
import "react-quill/dist/quill.snow.css";
import Quill from "react-quill";
import { updateBylineSubmission,getBylineSubmission } from "../../../services/employer";
import AppContext from "../../../contexts/AppContext";

class BylineModel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: {},
            errors: {}, 
            loading:false,  
            bylined: false,
            showBylineDiv : false             
        };
    }

    handleCheck = () => {
        this.setState({ showBylineDiv: this.state.showBylineDiv === true ? false : true });
    }

    handleCheckPaid = () => {
        let temp = this.state.item;
        temp["paid"] = this.state.item.paid === true ? false : true;
        this.setState({ item: temp });
    }

    handleChange = field => {
        let temp = this.state.item;
        let error = this.state.errors;
        temp[field.target.id] = field.target.value; 
        error[field.target.id] = null;   
        this.setState({ item: temp, errors: error });       
    };

    handleQuillChange = value => {
        let temp = this.state.item;
        temp.submission_note = value;

        let error = this.state.errors;
        error.submission_note = null;

        this.setState({ item: temp, errors: error });
    };

    handleValidation(){
        let fields = this.state.item;
        let errors = {};
        let formIsValid = true;

        if(!fields.submission_url){
            formIsValid = false;
            errors.submission_url = "Please enter submission url.";
        }        

        if(fields.submission_url && !(fields.submission_url).match(/\(?(?:(http|https|ftp):\/\/)?(?:((?:[^\W\s]|\.|-|[:]{1})+)@{1})?((?:www.)?(?:[^\W\s]|\.|-)+[\.][^\W\s]{2,4}|localhost(?=\/)|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::(\d*))?([\/]?[^\s\?]*[\/]{1})*(?:\/?([^\s\n\?\[\]\{\}\#]*(?:(?=\.)){1}|[^\s\n\?\[\]\{\}\.\#]*)?([\.]{1}[^\s\?\#]*)?)?(?:\?{1}([^\s\n\#\[\]]*))?([\#][^\s\n]*)?\)?/g))
        {
            formIsValid = false;
            errors.submission_url = "Please enter valid submission url.";
        }

        this.setState({errors: errors});
        return formIsValid;
    }

    update = e => {
        e.preventDefault();
        if(this.handleValidation()){
            const formData = new FormData();
            let errors = {};

            formData.append(
                'accept_byline_submission',
                this.state.showBylineDiv,
            );

            formData.append(
                'submission_url',
                this.state.item.submission_url,
            );

            formData.append(
                'paid',
                this.state.item.paid,
            );
            formData.append(
                'payout_start',
                this.state.item.payout_start,
            );

            formData.append(
                'payout_end',
                this.state.item.payout_end,
            );

            formData.append(
                'submission_note',
                this.state.item.submission_note,
            );

            formData.append(
                'user_id',
                this.props.item.id,
            );

            formData.append(
                'user_type',
                this.props.item.type,
            );

            updateBylineSubmission(formData)
            .then(response => {
                if(response.status == false)
                {
                    errors.url = response.message;
                    this.setState({errors: errors});
                }else{
                    this.context.state.showCodeMessage(
                        `Record has been updated!`,
                        "success"
                    );
                    this.props.hideByline();  
                               
                }
                
            })
            .catch(errors => {
                
            });
            
        }
    }

    componentDidMount() {
        let d = {
            id: this.props.item.id,
            type: this.props.item.type,
        };
        this.setState({ loading: true });
        getBylineSubmission(d).
        then(response => {
            //console.log(response.data);
            this.setState({ 
                item: {
                    "submission_url" : response.data.submission_url,
                    "submission_note" : response.data.submission_note,
                    "paid": response.data.paid,
                    "payout_start": response.data.payout_start,
                    "payout_end": response.data.payout_end,
                },           
                bylined: response.data.accept_byline_submission,
                showBylineDiv : response.data.accept_byline_submission, 
                loading: false
            });
            
        })
        .catch(errors => {
            
        });
        
    }
    
    render() {
        return (
            
            <div className="model-container model-center model-backdrop-show inviteModal">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <div className="model-header">                        
                        <h2 className="model-title" id="model-title">Bylined</h2>
                    </div>
                    
                    <div className="model-content">
                        {this.state.loading ? <div className="modalLoading">Loading...</div> : 
                            <form onSubmit={this.update} className="BylineForm">
                                <div className="form-group d-flex align-items-center">
                                    <div className="custom-control custom-switch mr-3">
                                        <input
                                            onChange={
                                                this.handleCheck
                                            }
                                            checked={
                                                this.state.showBylineDiv
                                            }
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="bylined_submissions"
                                        />
                                        <label
                                            className="custom-control-label"
                                            htmlFor="bylined_submissions"
                                        ></label>
                                    </div>
                                    <label className="mb-0">
                                        Accepts Bylined Submissions? <span className="ml-2" data-toggle="tooltip" data-placement="top" title="Do you accept and publish bylined article submissions from writers?"><i className="fe fe-help-circle"></i></span>
                                    </label>
                                </div>

                            { this.state.showBylineDiv ? 
                            <div>
                                    <div className="form-group">
                                    <label htmlFor="submission_url">
                                        Submissions Details URL
                                    </label>
                                    <input
                                        id="submission_url"  
                                        onChange={this.handleChange}                                   
                                        value={
                                            this.state.item.submission_url
                                        }                                   
                                        type="url"
                                        className="form-control"
                                    />
                                    {this.state.errors.submission_url ? (
                                                <div className="text-danger">
                                                    {this.state.errors.submission_url}
                                                </div>
                                            ) : null}
                                </div>

                                    <div className="form-group ">
                                        <label
                                            className="mb-1"
                                            htmlFor="description"
                                        >
                                            Submission Notes
                                        </label>
                                        <small className="form-text text-muted">
                                                Describe submission notes requirements.
                                        </small>
                                        <Quill
                                           
                                            onChange={this.handleQuillChange}
                                            value={
                                                this.state.item.submission_note
                                            }
                                        ></Quill>

                                        {this.state.errors.submission_note ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.submission_note}
                                            </div>
                                        ) : null}
                                    </div>
                            
                                    <div className="form-group">
                                        <label htmlFor="name">
                                            
                                        </label>
                                        <input
                                            checked={this.state.item.paid}  
                                            onChange={this.handleCheckPaid}                                 
                                            className="react-switch-checkbox"                                            
                                            type="checkbox"
                                        /> Paid
                                    </div> 
                                    {this.state.item.paid ? 
                                    
                                    <div className="form-group">
                                        <label htmlFor="name">
                                            Payout
                                        </label>
										<div className="d-flex align-items-center justify-content-between">
                                            <input
                                                id="payout_start"  
                                                name="payout_start"
                                                onChange={this.handleChange} 
                                                value={this.state.item.payout_start} 
                                                className="form-control input-sm"                                         
                                                type="number"
                                            /> 
										    <span className="ml-3 mr-3">-</span>
                                            <input
                                                id="payout_end"  
                                                name="payout_end"
                                                onChange={this.handleChange} 
                                                value={this.state.item.payout_end} 
                                                className="form-control input-sm"                                         
                                                type="number"
                                            />
										</div>
                                    </div> 
                                    
                                    : ''}       
                            </div>
                            : '' }
                             { this.state.showBylineDiv ? 
                            <button
                                type="button"
                                onClick={this.update}
                                className="btn btn-primary mr-2"
                            >
                                Submit
                            </button>
                            : '' }
                            <button
                                type="button"
                                onClick={this.props.hideByline}
                                className="btn btn-default"
                            >
                                Cancel
                            </button>
                        </form>
                        }
                    </div>
                    </div>
                   
                </div>
            
                   
        );
    }
}
BylineModel.contextType = AppContext;
export default BylineModel;



// WEBPACK FOOTER //
// ./src/components/admin/employers/BylineModel.js